import { useState, useEffect } from "react";
import { getBoards, getClasses, getSubjects, getNotes, getVideos } from "../api";

export function useBoards() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    getBoards()
      .then((res) => setData(Array.isArray(res) ? res : []))
      .catch((err) => setError(err?.response?.data?.message || "Failed to load boards"))
      .finally(() => setLoading(false));
  }, []); // runs once on mount

  return { data, loading, error };
}

export function useClasses(boardId) {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!boardId) { setData([]); return; }
    setLoading(true);
    setError(null);
    getClasses(boardId)
      .then((res) => setData(Array.isArray(res) ? res : []))
      .catch((err) => { setError(err?.response?.data?.message || "Failed to load classes"); setData([]); })
      .finally(() => setLoading(false));
  }, [boardId]);

  return { data, loading, error };
}

export function useSubjects(boardId, classId) {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!boardId || !classId) { setData([]); return; }
    setLoading(true);
    setError(null);
    getSubjects(boardId, classId)
      .then((res) => setData(Array.isArray(res) ? res : []))
      .catch((err) => { setError(err?.response?.data?.message || "Failed to load subjects"); setData([]); })
      .finally(() => setLoading(false));
  }, [boardId, classId]);

  return { data, loading, error };
}

export function useNotes(subjectId) {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!subjectId) { setData([]); return; }
    setLoading(true);
    setError(null);
    getNotes(subjectId)
      .then((res) => setData(Array.isArray(res) ? res : []))
      .catch((err) => { setError(err?.response?.data?.message || "Failed to load notes"); setData([]); })
      .finally(() => setLoading(false));
  }, [subjectId]);

  return { data, loading, error };
}

export function useVideos(subjectId) {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!subjectId) { setData([]); return; }
    setLoading(true);
    setError(null);
    getVideos(subjectId)
      .then((res) => setData(Array.isArray(res) ? res : []))
      .catch((err) => { setError(err?.response?.data?.message || "Failed to load videos"); setData([]); })
      .finally(() => setLoading(false));
  }, [subjectId]);

  return { data, loading, error };
}
